import { ValidationErrors } from '@angular/forms';

export const createValidationErrorObject = (message: string, params?: string[]) => ({
  invalid: true,
  valid: false,
  message,
  params
});

export const createValidationError = (key: string, message: string, params?: string[]): ValidationErrors => ({
  [key]: createValidationErrorObject(message, params)
});
